import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { Observable, of } from "rxjs";

import { DataProtectionConfigService } from "../data-protection.config";

@Injectable({
	providedIn: "root",
})
export class SubscriptionsDataProtectionGuard implements CanActivate {
	constructor(
		private dataProtectionConfig: DataProtectionConfigService,
		private store: Store<CoreState>
	) {}

	canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		if (this.dataProtectionConfig.getMarketingConsentDisabled()) {
			return of(true);
		}

		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.marketingSettings.marketingConsents));
		return of(false);
	}
}
